export default "* Følelser\n* Lytte\n* Fortælle\n* Spørgsmål\n";